import React from 'react';
import { string } from 'prop-types';
import styled, { keyframes } from 'styled-components';

import { primaryColor } from 'crehui/styles/colors';

const ldsRing = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const RingContainer = styled.div`
  display: inline-block;
  position: relative;
  width: ${props => props.size};
  height: ${props => props.size};

  &:nth-child(1) {
    animation-delay: -0.45s;
  }
  &:nth-child(2) {
    animation-delay: -0.3s;
  }
  &:nth-child(3) {
    animation-delay: -0.15s;
  }
`;

const Ring = styled.div`
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: ${props => props.size};
  height: ${props => props.size};
  margin: 6px;
  border: ${props => props.border} solid ${props => props.color};
  border-radius: 50%;
  animation: ${ldsRing} 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: ${props => props.color} transparent transparent transparent;
`;

const LoaderRing = ({ sizeContainer, sizeRing, border, color }) => (
  <RingContainer size={sizeContainer}>
    <Ring size={sizeRing} border={border} color={color} />
    <Ring size={sizeRing} border={border} color={color} />
    <Ring size={sizeRing} border={border} color={color} />
    <Ring size={sizeRing} border={border} color={color} />
  </RingContainer>
);

LoaderRing.defaultProps = {
  sizeContainer: '90px',
  sizeRing: '80px',
  border: '6px',
  color: `${primaryColor}`,
};

LoaderRing.propTypes = {
  sizeContainer: string,
  color: string,
  sizeRing: string,
  border: string,
};

export default LoaderRing;
